module.exports = __webpack_public_path__ + "img/img-joker-d.a6ea5fb7.png";